import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  Panel,
  Col,
  Message,
  Cascader,
  ControlLabel,
  Button,
  Row,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
} from 'rsuite'
import NumberFormat from 'react-number-format'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  saveBudgetPlanAtInstallmentStepMuti,
  saveBudgetPlanMuti,
} from '../../../redux/actions/paymentSave'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import EditButton from '../../../components/buttons/editButton/EditButton'

export default function BudgetPlanMuti({
  header,
  isEditable,
  isEdit: _isEdit,
  isEditCancle,
  masterBudgetPlan: _masterBudgetPlan,
  masterBudgetValue: _masterBudgetValue,
  subBudgetPlan: _subBudgetPlan,
  subBudgetValue: _subBudgetValue,
  limitBudgetValue,
  projectIdList,
  onComplete,
  shaded,
  isSaveBudgetPlanStep,
  skipReserveEbudget,
}) {
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
  } = useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(isEditable && _isEdit)
  const [isError, setIsError] = useState(false)
  const [masterBudgetPlan, setMasterBudgetPlan] = useState(_masterBudgetPlan)
  const [masterBudgetValue, setMasterBudgetValue] = useState(_masterBudgetValue)
  const [subBudgetPlan, setSubBudgetPlan] = useState(_subBudgetPlan)
  const [subBudgetValue, setSubBudgetValue] = useState(_subBudgetValue)

  const [isSubBudgetPlan, setIsSubBudgetPlan] = useState(
    _subBudgetPlan?.value || _subBudgetValue?.value ? true : false
  )
  const [skipReserveEbudgetValue, setSkipReserveEbudgetValue] = useState(skipReserveEbudget ? 1 : 0)

  const watchMainBudgetPlan = watch('masterBudgetPlan', masterBudgetPlan?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveBudgetPlan = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (isSaveBudgetPlanStep) {
        await saveBudgetPlanMuti(request)
      } else {
        await saveBudgetPlanAtInstallmentStepMuti(request)
      }
      if (typeof onComplete === 'function') {
        onComplete()
      }
      if (isEditCancle) {
        setIsEdit(false)
      }
    } catch (e) {
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    const request = {
      projectVersionIds: projectIdList,
      masterBudgetPlanValue: data.masterBudgetPlan,
      subBudgetPlanValue: data.subBudgetPlan,
      masterBudgetValue: data.masterBudgetValue || 0,
      subBudgetValue: data.subBudgetValue || 0,
      skipReserveEbudget: data.skipReserveEbudget,
    }
    // console.log('request', request)
    handleSaveBudgetPlan(request)
  }

  return (
    <Panel header={header} bordered collapsible defaultExpanded shaded={shaded}>
      {masterBudgetPlan && (
        <div>
          {isEdit ? (
            <Row>
              <Col style={{ marginTop: '10px' }}>
                <ControlLabel
                  style={{ fontWeight: 'bold' }}
                  className={classNames(isRequired(masterBudgetPlan?.validators) && 'required')}
                >
                  {masterBudgetPlan?.label}
                </ControlLabel>
                <ErrorMessage error={errors.masterBudgetPlan} />
                <Controller
                  name={'masterBudgetPlan'}
                  control={control}
                  defaultValue={masterBudgetPlan?.value}
                  rules={isValidators(masterBudgetPlan?.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={masterBudgetPlan?.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setValue('subBudgetPlan', null)
                        }}
                        placeholder={masterBudgetPlan?.label}
                      ></Cascader>
                    )
                  }}
                />
              </Col>

              <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: '10px' }}>
                <ErrorMessage error={errors.masterBudgetValue} />
                <ControlLabel
                  className={classNames(isRequired(masterBudgetValue?.validators) && 'required')}
                >
                  {masterBudgetValue?.label}
                </ControlLabel>
                <Controller
                  name={'masterBudgetValue'}
                  control={control}
                  defaultValue={masterBudgetValue?.value || limitBudgetValue / 2 || ''}
                  rules={isValidators(masterBudgetValue?.validators)}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        placeholder={masterBudgetValue?.label}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                style={{ marginTop: '20px', marginBottom: isSubBudgetPlan ? 0 : 40 }}
              >
                <IconButton
                  appearance="ghost"
                  className={isSubBudgetPlan ? 'rs-btn-ghost-cancel' : ''}
                  onClick={() => {
                    setIsSubBudgetPlan(!isSubBudgetPlan)
                  }}
                  icon={
                    <Icon
                      appearance="ghost"
                      icon={isSubBudgetPlan ? 'trash' : 'plus'}
                      className={
                        isSubBudgetPlan ? 'bt-gost-icon-radius-cancel' : 'bt-gost-icon-radius'
                      }
                    />
                  }
                >
                  {isSubBudgetPlan ? 'ลบแผนรอง' : 'ระบุแผนรอง (ถ้ามี)'}
                </IconButton>
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                <Controller
                  name={'skipReserveEbudget'}
                  control={control}
                  defaultValue={skipReserveEbudgetValue}
                  // rule={register(isValidators(schema.reviewerFilter.validators))}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        value={skipReserveEbudgetValue}
                        onChange={(value) => {
                          console.log('value => ', value)
                          props.onChange(value)
                          setSkipReserveEbudgetValue(value)
                        }}
                      >
                        {[
                          { label: 'อนุมัติในปีงบประมาณนี้', value: 0, disabled: null },
                          { label: 'อนุมัติในปีงบประมาณถัดไป', value: 1, disabled: null },
                        ].map((item) => (
                          <Radio
                            key={item.value}
                            value={item.value}
                            // disabled={schema.reviewerFilter.disabled || disabledForm}
                          >
                            <p style={{ marginTop: -1 }}>{item.label}</p>
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
                {/* <Checkbox
                defaultChecked={skipReserveEbudgetValue}
                onChange={(_, checked) => {
                  console.log('value selected ', checked)
                  setSkipReserveEbudgetValue(checked)
                }}
              >
                {' '}
                <p style={{ marginTop: -3 }}>ยังไม่ต้องจองงบประมาณตามแผนที่เลือก</p>
              </Checkbox> */}
              </Col>
            </Row>
          ) : (
            <>
              <p style={{ fontWeight: 'bold' }}>{masterBudgetPlan?.label}</p>
              <p>{masterBudgetPlan?.text ? masterBudgetPlan?.text : '-'}</p>
              <p>{`${masterBudgetValue?.label || ''} ${(
                masterBudgetValue?.value || 0
              ).toLocaleString()} บาท`}</p>
            </>
          )}
        </div>
      )}

      {isSubBudgetPlan && (
        <div style={{ marginTop: 20 }}>
          {isEdit ? (
            <Row>
              <Col style={{ marginTop: '10px' }}>
                <ControlLabel
                  style={{ fontWeight: 'bold' }}
                  className={classNames(isRequired(subBudgetPlan?.validators) && 'required')}
                >
                  {subBudgetPlan?.label}
                </ControlLabel>
                <ErrorMessage error={errors.subBudgetPlan} />
                <Controller
                  name={'subBudgetPlan'}
                  control={control}
                  defaultValue={subBudgetPlan.value}
                  rules={isValidators(subBudgetPlan.validators)}
                  render={(props) => {
                    return (
                      <Cascader
                        size="lg"
                        block
                        menuWidth={220}
                        data={subBudgetPlan.items}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                        placeholder={subBudgetPlan?.label}
                        disabledItemValues={[watchMainBudgetPlan]}
                        disabled={!watchMainBudgetPlan}
                      ></Cascader>
                    )
                  }}
                />
              </Col>

              <Col xs={24} sm={24} md={12} lg={8} style={{ marginTop: '10px' }}>
                <ErrorMessage error={errors.subBudgetValue} />
                <ControlLabel
                  className={classNames(isRequired(subBudgetValue?.validators) && 'required')}
                >
                  {subBudgetValue?.label}
                </ControlLabel>
                <Controller
                  name={'subBudgetValue'}
                  control={control}
                  defaultValue={subBudgetValue?.value || limitBudgetValue / 2 || ''}
                  rules={isValidators(subBudgetValue?.validators)}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        placeholder={subBudgetValue?.label}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          ) : (
            <>
              <p style={{ fontWeight: 'bold' }}>{subBudgetPlan?.label}</p>
              <p>{subBudgetPlan?.text ? subBudgetPlan?.text : '-'}</p>
              <p>{`${subBudgetValue?.label || ''} ${(
                subBudgetValue?.value || 0
              ).toLocaleString()} บาท`}</p>
            </>
          )}
        </div>
      )}

      {isEditable && (
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          style={{ marginBottom: 20, marginTop: 20, padding: 0 }}
        >
          {isEdit ? (
            <div>
              {isError && (
                <div style={{ marginBottom: 10 }}>
                  <Message
                    showIcon
                    type="error"
                    description={`เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                  />
                </div>
              )}
              <Button appearance="ghost" onClick={handleSubmit(onSubmit)}>
                บันทึกแผนงบประมาณไปยังทุกโครงการ
              </Button>
              {isEditCancle && (
                <Button
                  style={{ marginLeft: 20 }}
                  appearance="ghost"
                  onClick={() => {
                    setIsSubBudgetPlan(subBudgetPlan?.value || subBudgetPlan?.value ? true : false)
                    setIsEdit(false)
                  }}
                  disabled={isLoading}
                >
                  ยกเลิกการแก้ไข
                </Button>
              )}
            </div>
          ) : (
            <EditButton
              onClick={() => {
                setIsEdit(true)
              }}
            >
              แก้ไขแผน
            </EditButton>
          )}

          {/* <div>
            {isError && (
              <div style={{ marginBottom: 10 }}>
                <Message showIcon type="error" description={`เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`} />
              </div>
            )}
            <Button appearance="ghost" onClick={handleSubmit(onSubmit)}>
              บันทึกแผนงบประมาณไปยังทุกโครงการ
            </Button>
          </div> */}
        </Col>
      )}
    </Panel>
  )
}
